import React, { useState } from 'react';
import { motion } from 'framer-motion';
import closeFormBtn from '../../../assets/images/home_screen/close_form_btn.png';
import whiteLogo from '../../../assets/images/home_screen/white_Logo_1_1.png';
import mainImage from '../../../assets/images/home_screen/main-image.webp';
import { FaPlus } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const HeroSection = () => {
  const [isFormShown, setIsFormShown] = useState(true);
  const [loading, setLoading] = useState(false);
  // const [recaptchaToken, setRecaptchaToken] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const inputStyles =
    'bg-black/70 p-2 xl:p-1.5 2xl:p-2.5 3xl:p-3 text-sm xl:text-sm 2xl:text-base 3xl:text-lg text-gray-400 w-full';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
      )
      .join('&');
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    setLoading(true);

    await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'home-page-form', ...formData }),
    })
      .then(() => {
        toast.success(
          'Thank you for submitted the form! A staff member will be reaching out to you soon!',
          {
            progressClassName: 'gradient-progress-bar',
          }
        );
        setFormData({ name: '', phone: '', email: '', message: '' });
        setLoading(false);
      })
      .catch((error) => {
        toast.error(`Failed to send message: ${error.message}`);
        setLoading(false);
      });
  };

  return (
    <div
      className="relative h-[600px] 2xl:h-[700px] 4xl:h-[800px] 5xl:h-[987px] 3xl:h-[800px] w-full bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${mainImage})` }}
    >
      <div className="absolute inset-0 bg-black/10" />
      <div
        className={`absolute ${
          isFormShown ? 'left-2' : '-left-[230px]'
        } transition-all duration-300 ease-in-out top-10 z-20 hidden sm:block`}
      >
        <form
          onSubmit={sendEmail}
          className="flex flex-col p-3 bg-black/40 gap-2 pb-0 xl:gap-3 2xl:gap-4 rounded-lg w-[300px] xl:w-[330px] 2xl:w-[390px] 3xl:w-[430px] relative"
        >
          <p className="hidden">
            <label>
              Don't fill this out if you're human:
              <input name="bot-field" type="text" />
            </label>
          </p>
          <h2 className="mb-1 text-lg font-medium text-white md:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-5xl">
            BOOK YOUR <br /> EVALUATION TODAY!
          </h2>
          <input
            className={inputStyles}
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="name"
            required
          />
          <input
            className={inputStyles}
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="phone"
            type="tel"
            required
          />
          <input
            className={inputStyles}
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="email"
            type="email"
            required
          />
          <textarea
            className={inputStyles}
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="message"
            rows={4}
            required
          />
          <div className="flex items-center gap-3 mb-4 2xl:mb-[28px]">
            <button
              type="submit"
              disabled={loading}
              className={`gradientBorder ${
                loading
                  ? 'opacity-60 cursor-not-allowed'
                  : 'hover:bg-black/20 active:bg-black/30 hover:scale-105'
              } transition-all rounded-xl select-none flex items-center justify-center px-43 py-2 xl:px-4 xl:py-2`}
            >
              <p className="text-white"> {loading ? 'Sending' : 'Submit'}</p>
            </button>
          </div>

          <div
            onClick={() => setIsFormShown(!isFormShown)}
            className="absolute cursor-pointer top-2 right-2"
          >
            {isFormShown ? (
              <img src={closeFormBtn} alt="close-btn" width={20} />
            ) : (
              <FaPlus
                color="#00B7FF"
                className="bg-[#3A3230] text-xl p-[3px] rounded-full"
              />
            )}
          </div>
        </form>
      </div>

      <div className="absolute right-0 bottom-10 md:bottom-[20%] min-w-[95%] xs:min-w-[80%] md:min-w-[520px] 2xl:min-w-[620px] overflow-hidden">
        <motion.div
          initial={{ opacity: 0, x: 200 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.75, ease: 'easeOut' }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <img
            src={whiteLogo}
            alt="white-logo"
            className="w-[200px] lg:w-[300px] 2xl:w-[350px] md:w-[250px] 3xl:w-[420px] mb-8"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <p className="bg-gradient-to-r from-[#C672A7]/85 to-[#7F76AF]/85 text-white px-[5px] py-[4px] md:text-2xl lg:text-[28px] rounded-sm font-medium mb-2 lg:mb-3">
            Alaska's Choice
            <span className="text-sm font-normal md:text-lg">
              &nbsp; for Pediatric PT/OT/Speech Care
            </span>
          </p>
          <p className="text-white text-sm sm:text-[15px] lg:text-[16px] font-medium tracking-wider">
            Providing pediatric occupational, physical, and speech <br />{' '}
            evaluations in our Wasilla clinic.
          </p>
        </motion.div>
      </div>
      <ToastContainer position="bottom-left" autoClose={3000} theme="dark" />
    </div>
  );
};

export default HeroSection;
